.program-marker {
  position: absolute;
  z-index: calc(var(--player-base-z-index));
  padding: 2px 6px;
}

.program-marker-inner {
  width: 0.5rem;
  height: 4px;
  background-color: var(--rds-background-overlay-medium);
}

.program-marker:hover .program-marker-inner {
  transform: scale(1.5);
}

@media (--rds-media-ml) {
  .program-marker-image {
    display: none;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
